import { Injectable } from '@angular/core';
// import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, map, switchMap, exhaustMap, catchError, take, delay, first, mergeMap } from 'rxjs/operators';
import { get as _get } from 'lodash';
import { CrmGroup, CrmGroupMember } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
@Injectable()
export class CrmGroupsService {
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	getCrmGroups(id: string = null) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		let api = APIs.crm_groups;
		if (id) {
			api += '/' + id;
		} else {
			api += '?is_default_group_like=false&community_uuid_like=&';
		}
		return this._httpClient.get(api, { headers: headers });
	}
	getCrmGroupscrmuser(uuid) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		let api = `${APIs.crm_groups}/users`;
		let params: HttpParams = new HttpParams;
		params = params.set('crm_uuid', `${uuid}`);
		return this._httpClient.get(api, { headers: headers, params: params });
	}
	insertCrmGroup(body: CrmGroup) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_groups, body, { headers: headers });
	}
	hideMessage(uuid: any, is_hide) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.crm_group_chat}/hide_message/${uuid}?is_hide=${is_hide}`, { headers: headers });
	}
	updateCrmGroup(body: CrmGroup, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.crm_groups}/${uuid}`, body, { headers: headers });
	}
	deleteCrmGroup(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_groups}/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	getCrmGroupMembers(uuid: string) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		return this._httpClient.get(`${APIs.crm_groups}/${uuid}/members`, { headers: headers });
	}
	getCrmChannelMembers(uuid: string) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		return this._httpClient.get(`${APIs.crm_groups}/${uuid}/members_new`, { headers: headers });
	}
	insertCrmGroupMember(body: CrmGroupMember, uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.crm_groups}/${uuid}/members`, body, { headers: headers });
	}
	updateCrmGroupMember(body: CrmGroupMember, group_uuid: string, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.crm_groups}/${group_uuid}/members/${uuid}`, body, { headers: headers });
	}
	deleteCrmGroupMember(group_uuid: string, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		const api = `${APIs.crm_groups}/${group_uuid}/members/${uuid}`;
		return this._httpClient.delete(api, { headers: headers });
	}
	getCrmGroupMessages(group_uuid: string) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		let api = APIs.crm_group_chat;
		api += '/messages/' + group_uuid;
		return this._httpClient.get(api, { headers: headers });
	}
	sendGroupMessage(data: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		}
		return this._httpClient.post(`${APIs.crm_group_chat}/send-message`, data, { headers: headers });
	}
	getGroupConversationUsers() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		}
		return this._httpClient.get(`${APIs.crm_group_chat}/users`, { headers: headers });
	}
	getLanguageUsernames(languageid: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers) {
			return of(null);
		}
		return this._httpClient.get(`${APIs.users}/getusers`, {
			params: {
				language_id: languageid
			}
		});
	}
	createChannel(body: CrmGroup) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.crm_groups + '/create_new_channel', body, { headers: headers });
	}
	makeHimExpert(memberUUID: string) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		return this._httpClient.get(`${APIs.crm_groups}/${memberUUID}/make_expert`, { headers: headers });
	}
	revokeExpert(memberUUID: string) {
		const headers = this._httpHeaderService.getNormalHttpHeader();
		return this._httpClient.get(`${APIs.crm_groups}/${memberUUID}/revoke_expert`, { headers: headers });
	}
}
